import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CreditMatchOnboarding from "@/pages/CreditMatchOnboarding";
import { Navigate } from "@/lib/router-compat";
import { CREDIT_KARMA_OFFER_ENABLED } from "@/config/featureFlags";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/onboarding/credit-match")({
  head: () => seoHead("/onboarding/credit-match"),
  component: () => (
    CREDIT_KARMA_OFFER_ENABLED ? <AuthGate><CreditMatchOnboarding /></AuthGate> : <Navigate to="/credit-readiness" replace />
  ),
});
